// extracted by mini-css-extract-plugin
export default {"root":"RollContent__root--NuGBZ","root_dark":"RollContent__root_dark--2_R5P","placeholder":"RollContent__placeholder--3_sMO","button":"RollContent__button--1-4dB"};